import React, { useEffect, useState } from "react";
import { Tabs, Table, Tag, Button, message, Tooltip } from "antd";
import Search from "../components/search";
import { Date } from "../components/formatter";
import {
  FileDoneOutlined,
  CloseCircleOutlined,
  IssuesCloseOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState();
  const [isRequest, setIsRequest] = useState(false);
  const [active, setActive] = useState("hotels");

  const login = JSON.parse(localStorage.getItem("login"));

  const onChange = (key) => {
    setActive(key);
  };

  const getColumns = () => {
    let columns = [
      {
        title: "Request Date",
        dataIndex: "requestDate",
        key: "requestDate",
        render: (text, record) => (
          <div>
            <div className="small text-secondary">#00000{record?.id}</div>
            <div className="text-nowrap">{Date(text)}</div>
          </div>
        ),
        width: 142,
      },
      {
        title: "Requested by",
        dataIndex: "requestedBy",
        key: "requestedBy",
        render: (text, record) => (
          <div>
            <div className="">Employee</div>
            <div className="small text-secondary">employee@gmail.com</div>
          </div>
        ),
      },
      {
        title: "Details",
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <React.Fragment>
            {record?.type === "Hotel" && (
              <div>
                <div className="fw-bold">{text}</div>
                <div className="mt-1 text-secondary small">{record?.dates}</div>
              </div>
            )}

            {record?.type === "Expense" && (
              <div>
                <div className="fw-bold">{record?.expenseType}</div>
                <div className="mt-1 text-secondary small">{record?.date}</div>
              </div>
            )}
          </React.Fragment>
        ),
      },
      {
        title: "Price",
        dataIndex: "price",
        key: "price",
        render: (text, record) => (
          <div>
            <div className="fw-bold">{text}</div>
            {record?.type === "Hotel" && (
              <div className="mt-1 text-secondary small">for 1 night</div>
            )}
          </div>
        ),
        width: 180,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        render: (text, record) => (
          <React.Fragment>
            <Tag
              color={
                record.status === "Confirmed"
                  ? "green"
                  : record.status === "Approved"
                  ? "orange"
                  : record.status === "Denied"
                  ? "cyan"
                  : record.status === "Cancelled"
                  ? ""
                  : "blue"
              }
            >
              {text}
            </Tag>
            <div className="small mt-1">{record?.brn || ""}</div>
          </React.Fragment>
        ),
        width: 180,
      },
      {
        title: "Actions",
        key: "employeeActions",
        width: 1,
        align: "center",
        render: (text, record) => (
          <div className="d-flex justify-content-center">
            {(record?.status === "New" || record?.status === "Approved") && (
              <Tooltip title="Cancel">
                <Button
                  className="reset-icon-btn"
                  type="link"
                  onClick={() => handleCancel(record)}
                  icon={<CloseCircleOutlined />}
                />
              </Tooltip>
            )}
            {record?.status === "Confirmed" && (
              <Tooltip title="Voucher">
                <Button
                  className="reset-icon-btn"
                  type="link"
                  onClick={() => handleVoucher(record)}
                  icon={<FileDoneOutlined />}
                />
              </Tooltip>
            )}
          </div>
        ),
        width: 100,
      },
      {
        title: "Actions",
        key: "approverActions",
        width: 1,
        render: (text, record) =>
          record?.status === "New" && (
            <div className="d-flex">
              <Tooltip title="Approve">
                <Button
                  type="link"
                  onClick={() => handleApprove(record)}
                  icon={<CheckCircleOutlined />}
                />
              </Tooltip>
              <Tooltip title="Deny">
                <Button
                  className="reset-icon-btn me-2"
                  type="link"
                  onClick={() => handleDeny(record)}
                  icon={<IssuesCloseOutlined />}
                />
              </Tooltip>
            </div>
          ),
      },
      {
        title: "Actions",
        key: "supplierActions",
        width: 1,
        render: (text, record) =>
          record?.status === "Approved" && (
            <div className="d-flex">
              <Button
                type="primary"
                className="me-3"
                onClick={() => handleConfirm(record)}
              >
                Confirm
              </Button>
            </div>
          ),
      },
    ];

    if (login?.type === "Employee") {
      return columns.filter(
        (x) =>
          x.key !== "requestedBy" &&
          x.key !== "approverActions" &&
          x.key !== "supplierActions"
      );
    }

    if (login?.type === "Approver") {
      return columns.filter(
        (x) => x.key !== "employeeActions" && x.key !== "supplierActions"
      );
    }

    if (login?.type === "Admin") {
      return columns.filter(
        (x) =>
          x.key !== "employeeActions" &&
          x.key !== "approverActions" &&
          x.key !== "supplierActions"
      );
    }

    if (login?.type === "Supplier") {
      return columns.filter(
        (x) => x.key !== "employeeActions" && x.key !== "approverActions"
      );
    }

    return columns;
  };

  const setRequestData = () => {
    let data = JSON.parse(localStorage.getItem("reqData")).sort(
      (a, b) => b.id - a.id
    );

    if (login?.type === "Supplier")
      data = data.filter((x) => x?.status !== "New");

    setData(data);
  };

  const handleApprove = (record) => {
    const updatedData = data.map((item) =>
      item.id === record.id ? { ...item, status: "Approved" } : item
    );
    message.success("Request #00000" + record?.id + " Approved successfully.");
    setData(updatedData);
    localStorage.setItem("reqData", JSON.stringify(updatedData));
  };

  const handleDeny = (record) => {
    const updatedData = data.map((item) =>
      item.id === record.id ? { ...item, status: "Denied" } : item
    );
    message.success("Request #00000" + record?.id + " Denied successfully.");
    setData(updatedData);
    localStorage.setItem("reqData", JSON.stringify(updatedData));
  };

  const handleConfirm = (record) => {
    const updatedData = data.map((item) =>
      item.id === record.id
        ? {
            ...item,
            status: "Confirmed",
            brn: "BRN-" + dayjs().format("MMDDYYYY") + "-00" + item.id,
          }
        : item
    );
    message.success("Request #00000" + record?.id + " Confirmed successfully.");
    setData(updatedData);
    localStorage.setItem("reqData", JSON.stringify(updatedData));
  };

  const handleCancel = (record) => {
    const updatedData = data.map((item) =>
      item.id === record.id ? { ...item, status: "Cancelled" } : item
    );
    message.success("Request #00000" + record?.id + " Cancelled successfully.");
    setData(updatedData);
    localStorage.setItem("reqData", JSON.stringify(updatedData));
  };

  const handleVoucher = (record) => {
    console.log(record);
  };

  const items = [
    {
      key: "hotels",
      label: "Hotels",
      children: <Search active={active} />,
    },
    {
      key: "flights",
      label: "Flights",
      children: <Search active={active} />,
    },
    {
      key: "cars",
      label: "Cars",
      children: <Search active={active} />,
    },
    {
      key: "expenses",
      label: "Other Expenses",
      children: (
        <Search active={active} handleUpdate={(reqData) => setData(reqData)} />
      ),
    },
  ];

  useEffect(() => {
    setRequestData();
  }, []);

  return (
    <div className="mt-4">
      <div className="container">
        {login?.type === "Employee" && (
          <Tabs defaultActiveKey={active} items={items} onChange={onChange} />
        )}

        <Table
          columns={getColumns()}
          rowKey={(record) => record?.id}
          dataSource={data?.sort((a, b) => b.id - a.id) || []}
          pagination={false}
          bordered
          scroll={{ x: 400 }}
          size="small"
          className="mt-4"
        />
      </div>
    </div>
  );
};

export default Dashboard;
